<template>
  <div class="relative z-10 pointer-events-none" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-200 pointer-events-none opacity-0" :class="show && 'pointer-events-auto !opacity-100'" @click.self.stop="show = false"></div>

    <div class="fixed inset-0 z-10 overflow-y-auto pointer-events-none">
      <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
        <transition
          enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          leave-class="opacity-100 translate-y-0 sm:scale-100"
          enter-to-class="opacity-100 translate-y-0 sm:scale-100"
          leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div v-if="show" class="pointer-events-auto relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
            <div class="sm:flex sm:items-start">
              <div class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-blue-600">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" />
                </svg>
              </div>
              <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">Create a name for your custom link</h3>
                <div class="mt-4">
                  <input v-model="name" type="text" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6" placeholder="E.g. Ramadan books...">
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button @click="save" type="button" class="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto">Create link</button>
              <button @click="show = false" type="button" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">Cancel</button>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['value'],
  data() {
    return {
      show: this.value,
      name: "",
    }
  },
  methods: {
    save() {
      if (!this.name) {
        this.$store.dispatch("toast/error", { message: "Please create a name for this link" })
        return;
      }
      this.$emit('save', this.name)
      this.show = false
    },
  },
  watch: {
    show(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.show = val
    },
  },
}

</script>
